"use client";
import { RECAPTCHA_KEY } from "@/constants/googleKeys";
import { loadRecaptcha } from "@/utils/recaptcha-loader";

const useRecaptcha = () => {
  const getCaptchaToken = async (action) => {
    try {
      const grecaptcha = await loadRecaptcha();
      const token = await grecaptcha.execute(RECAPTCHA_KEY, {
        action: action,
      });
      return token;
    } catch (error) {
      console.error("reCAPTCHA hatası:", error);
      throw error;
    }
  };

  return { getCaptchaToken };
};

export default useRecaptcha;
